<template>
  <div class="deviceoperateNew">
    <!-- 我的设备 -->
    <!-- {{deviceInfo}} -->
    <!-- {{deviceStatus}} -->
    <span class="top-info">
      <span class="label">
        <i class="status-icon-shadow" :class="deviceStatus.class"></i>
      </span>
      <span class="namebox">
        <span class="name">{{ deviceInfo.devalias || deviceInfo.sn }}</span>
      </span>
      <el-button type="text" class="operation" style="color: @primaryTextColor; margin-left: 6px"
        :title="$t('device.edit')" @click="editDevice(deviceInfo)">
        <i class="iconfont icon-bianji"></i>
        <!-- <i class="ico-edit"></i> -->
      </el-button>
    </span>
    <div class="top-operate gOperate">
      <div class="gRowOne">
        <el-button type="text" class="operation" @click="followDevice(deviceInfo)">
          <!-- followactive -->
          <!-- <i class="iconfont icon-tianjia"></i> -->
          <i class="icobase followno" :class="{ followyes: followactive }"></i>
          <span class="icon-text1">{{
            followactive ? $t("device.unfollow") : $t("device.follow")
          }}</span>
        </el-button>
        <!-- 导出设备报表(此期暂时注释) -->
        <!-- @click="exportDevice(deviceInfo.pn)" -->
        <el-button type="text" class="operation" @click="exportPlant([deviceInfo])">
          <i class="iconfont icon-baobiao"></i>
          <span class="icon-text1">{{ $t('device.report') }}</span>
        </el-button>
        <!-- <el-button
          type="text"
          class="operation"
          :title="$t('device.edit')"
          @click="editDevice(scope.row)"
        >
          <i class="iconfont icon-edit"></i>
        </el-button>-->
        <!-- :title="$t('device.debug')" -->
        <el-button type="text" class="operation" @click="debugDevice(deviceInfo)">
          <i class="iconfont icon-caozuo_tiaoshi"></i>
          <!-- <i class="icobase ico-debug"></i> -->
          <span class="icon-text1">{{ $t("device.debug") }}</span>
        </el-button>
        <!-- :title="$t('device.control')" -->
        <el-button type="text" class="operation" @click="controlDevice(deviceInfo)">
          <i class="iconfont icon-kongzhi"></i>
          <!-- <i class="icobase ico-control"></i> -->
          <span class="icon-text1">{{ $t("device.control") }}</span>
        </el-button>
      </div>
      <div class="gRowTwo">
        <!-- :title="$t('device.upgrade')" -->
        <el-button type="text" :disabled="upgradeDeviceDisabled" class="operation" @click="upgradeDevice(deviceInfo)">
          <i class="iconfont icon-shengji"></i>
          <!-- <i class="icobase ico-upgrade"></i> -->
          <span class="icon-text1">{{ $t("device.upDevice") }}</span>
        </el-button>
        <!-- :title="$t('device.delete')" -->
        <el-button type="text" class="operation delBgc" @click="deleteDevice(deviceInfo)">
          <i class="iconfont icon-shanchu"></i>
          <!-- <i class="icobase ico-delete"></i> -->
          <span class="icon-text1">{{ $t("device.delete") }}</span>
        </el-button>
      </div>
    </div>

    <!-- 导出报表 -->
    <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>

    <!-- 编辑设备 -->
    <!-- v-if="editDeviceVisible" -->
    <device-dialog :title="$t('device.modify_alias')" :visible.sync="editDeviceVisible"
      :class="{ showDialog: editDeviceVisible, hideDialog: !editDeviceVisible }" noFooter>
      <div slot="content">
        <el-form class="grid">
          <!-- <el-form-item :label="$t('device.serial_number')" prop="sn" size="small">
              <el-input v-model="formEdit.sn" disabled></el-input>
          </el-form-item>-->
          <!-- <el-form-item :label="$t('device.device_code_form')" prop="devcode" size="small">
              <el-input v-model="formEdit.devcode" disabled></el-input>
          </el-form-item>-->
          <el-form-item :label="$t('device.device_alias')" prop="devalias" size="small">
            <el-input v-model="formEdit.devalias" clearable maxlength="20" @input="handleDevaliasInput" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <button type="button" class="btn btn-dark" @click="submitEditDevice">
            {{ $t("device.confirm") }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-hollow" @click="editDeviceVisible = false">{{$t('device.cancel')}}</button> -->
        <!-- <button class="button-solid" @click="submitEditDevice">{{$t('device.confirm')}}</button> -->
      </div>
    </device-dialog>
    <!-- 修改设备结果提示(成功) -->
    <!-- v-if="editDeviceSucVisible" -->
    <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceSucVisible" :class="{
      showDialog: editDeviceSucVisible,
      hideDialog: !editDeviceSucVisible,
    }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t("project.editSuc") }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="editDeviceSucVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 修改设备结果提示(失败) -->
    <!-- v-if="editDeviceFailVisible" -->
    <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceFailVisible" :class="{
      showDialog: editDeviceFailVisible,
      hideDialog: !editDeviceFailVisible,
    }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="editDeviceFailVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!-- 逆变器调试 -->
    <!-- v-if="debugDeviceVisible" -->
    <device-dialog :title="$t('device.debug')" :visible.sync="debugDeviceVisible" :class="{
      showDialog: debugDeviceVisible,
      hideDialog: !debugDeviceVisible,
    }" noFooter>
      <div slot="content">
        <el-form slot="content" class="grid">
          <el-form-item :label="$t('device.Device_pn')" size="small">
            <el-input v-model="device.pn" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('device.Instruction')" size="small">
            <el-input v-model="devDebug.cmd" :placeholder="$t('device.such_as')" type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }" auto-complete="off"></el-input>
          </el-form-item>
          <!-- 发送指令 -->
          <el-form-item label=" ">
            <div style="text-align: right">
              <button type="button" class="btn btn-dark" @click="submitDebugDevice()">
                {{ $t("device.send") }}
              </button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('device.return_content')" size="small">
            <div class="debug-return">
              <!-- id="link" -->
              <el-input readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
              <div class="return-tool">
                <span class="btn" style="margin-right: 15px" @click="fuzhi($event)" data-clipboard-action="copy"
                  data-clipboard-target="#link">
                  <i class="ico ico-copy"></i>
                  {{ $t("device.copy_val") }}
                </span>
                <span class="btn" @click="qingkong()">
                  <i class="ico ico-clear"></i>
                  {{ $t("device.clear_val") }}
                </span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <!-- <button 
            class="button-hollow" 
            @click="qingkong()"
        >{{$t('device.clear_data')}}</button>-->
        <!-- <button
            class="button-solid"
            type="primary"
            @click="submitDebugDevice()"
        >{{$t('device.send')}}</button>-->
      </div>
    </device-dialog>

    <!-- 控制项 -->
    <!-- v-if="controlDeviceVisible" -->
    <control-dialog :title="$t('device.control')" :width="'1000px'" :class="{
      showDialog: controlDeviceVisible,
      hideDialog: !controlDeviceVisible,
    }" :visible.sync="controlDeviceVisible" noFooter>
      <div @click="clickClosePicker()" class="control" slot="content" ref="controlContent">
           <div v-if="vendorFlag" style="width: 100%; text-align: right; padding-right: 40px;padding-bottom: 10px;background: #222d35;">
             <el-button v-loading="oneClickReadFlag" style="
                  height: 30px;
                  color: #fff;
                  background-color: rgba(23, 194, 133, 0.5);
                " @click="screenshot()" class="submit-control btn btn-dark">
                {{ $t("control.screenshot") }}
              </el-button>
           </div>
              <!-- 模式切换 -->
            <device-dialog
              :title="$t('control.TouSetting')"
              :class="{ 'showDialog': swichModeVisible, 'hideDialog': !swichModeVisible }"
              :visible.sync="swichModeVisible"
              append-to-body
              noFooter
            >
              <div slot="content">
                <div style="color:#EC9630;font-size:18px;font-weight:700;margin-bottom:50px;">
                  <span>{{ $t("control.confirmModeSwitch") }}</span>
                </div>
                <div style="text-align:right;">
                  <button
                    class="btn btn-light"
                    style="margin-right:10px;"
                    @click="swichModeCencel()"
                  >
                    {{
                    $t('device.cancel') }}
                  </button>
                  <button
                    class="btn btn-dark"
                    @click="swichModeConfirm()"
                  >
                    <span>{{ $t('device.confirm') }}</span>
                  </button>
                </div>
              </div>
              <div slot="footer"></div>
            </device-dialog>
           <div v-if="touFalg&&(deviceInfo.devcode=='6605'||deviceInfo.devcode=='6596'||deviceInfo.devcode=='6629'||deviceInfo.devcode=='6638'||deviceInfo.devcode=='6445')">
             <!-- <div style="height: 40px;" class="tableTitle">{{ $t('control.TouSetting') }}</div> -->
            <el-collapse v-model="activeTouGroups">
              <el-collapse-item :title="$t('control.TouSetting')" name="1">

                <div v-for="(Obj,index) in touArr" :key="index" style="padding: 0 20px;">
                  <div v-if="Obj.items.length>0">
                    <div class="tableTitle">
                      <el-radio @change="swichMode(Obj)" v-model="selectedRadio" :label="Obj.value" class="custom-radio">
                        {{ Obj.name }}
                      </el-radio>
                    </div>
                    <el-table  :data="Obj.items" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
                      <el-table-column :class-name="analysisFlag?'name-col':''"  prop="name" :label="$t('device.Field_Name')" width="250px">
                        <template slot-scope="scope">
                          <span style="padding:0 10px 0 0;" v-if="scope.row.id =='time'||scope.row.id =='time1'||scope.row.id =='time2'||scope.row.id =='time3'||scope.row.id=='time4'||scope.row.id=='time5'">
                            <el-checkbox v-model="scope.row.timeTo"></el-checkbox>
                          </span>
                          <span>{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="unit" width="250px" :label="$t('device.Unit')">
                        <template slot-scope="scope">
                          <div v-if="scope.row.id =='time'||scope.row.id =='time1'||scope.row.id =='time2'||scope.row.id =='time3'||scope.row.id=='time4'||scope.row.id=='time5'">
                            <div style="display: flex;align-items: center;">
    
                              <el-time-picker
                                v-model="scope.row.startTime"
                                format="HH:mm"
                                value-format="HH:mm"
                                popper-class="select-date3" 
                                :clearable="false"
                                :editable="false"
                                :ref="`controlDatepickerRef-${scope.row.id}-start`"
                                :placeholder="$t('actionLog.startTime')">
                              </el-time-picker>
                              <div style="padding: 0 5px;">~</div>
                              <el-time-picker
                                v-model="scope.row.endTime"
                                format="HH:mm"
                                value-format="HH:mm"
                                popper-class="select-date3" 
                                :clearable="false"
                                :editable="false"
                                :ref="`controlDatepickerRef-${scope.row.id}-end`"
                                :placeholder="$t('actionLog.endTime')">
                              </el-time-picker>
                            </div>
                          </div>
                          <div v-else>{{ scope.row.unit }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('device.set')" min-width="160px">
                        <template slot-scope="scope">
                          <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                            popper-class="select-search-recharge">
                            <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                              :value="item.value"></el-option>
                          </el-select>
                          <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                            <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                              :append-to-body="false"
                              type="datetime"
                              :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                            </el-date-picker>
                          </div>
                          <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                            :placeholder="scope.row.hint"></el-input>
                          <el-input v-model="scope.row.controlvalue" v-else></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column width="200px" :label="$t('device.Operation')">
                        <template slot-scope="scope">
                          <div v-if="scope.row.id !='time'&&scope.row.id !='time1'&&scope.row.id !='time2'&&scope.row.id !='time3'&&scope.row.id!='time4'&&scope.row.id!='time5'" class="instructieClass">
                            <el-button v-loading="scope.row.isLoading && selectbtnId !== 'async-weekday'" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                              <i class="iconfont icon-shuaxin"></i>
                              <span>{{$t('device.read') }}</span>
                            </el-button>
                            <!-- Obj.value != selectedRadio -->
                            <el-button :style="{opacity:Obj.value != selectedRadio? 0.5:1}" :disabled="Obj.value != selectedRadio" v-if="scope.row.id=='weekday'" v-loading="scope.row.Loading && selectbtnId !== 'async-weekday'" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="setOneTimeOfUse(scope.row)" class="submit-control btn btn-dark">
                              <i class="iconfont icon-caozuo_tiaoshi"></i>
                              <span>{{$t('device.distribute') }}</span>
                            </el-button>
                            <el-button :style="{opacity:Obj.value != selectedRadio? 0.5:1}" :disabled="Obj.value != selectedRadio" v-else v-loading="scope.row.Loading && selectbtnId !== 'async-weekday'" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                              <i class="iconfont icon-caozuo_tiaoshi"></i>
                              <span>{{$t('device.distribute') }}</span>
                            </el-button>
                          </div>
                          <div class="instructieClass">
                            <el-button :style="{opacity:Obj.value != selectedRadio? 0.5:1}" :disabled="Obj.value != selectedRadio" v-if="scope.row.id=='weekday'" v-loading="(scope.row.isLoading || scope.row.Loading) && selectbtnId == 'async-weekday'" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);margin-top: 5px;" @click="setWeekTimeOfUse(scope.row)" class="submit-control btn btn-dark">
                              <i class="iconfont icon-shuaxin"></i>
                              <span>{{$t('control.syncSetDay') }}</span>
                            </el-button>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
           </div>
           <div v-if="showOneClickReadBtn || vcodesFlag" style="width: 100%; text-align: right; padding-right: 40px;background: #222d35;">
             <el-button v-loading="oneClickReadFlag" style="
                 height: 30px;
                 color: #fff;
                 background-color: rgba(23, 194, 133, 0.5);
               " @click="oneClickRead()" class="submit-control btn btn-dark">
               {{ $t("device.one_click_read") }}
             </el-button>
           </div>
           <el-collapse v-model="activeGroups">
             <template v-for="group in controlTableGroups">
               <el-collapse-item v-if="group.data.length" :key="group.key" :title="$t(group.title)" :name="group.key">
                 <!-- <div class="tableTitle">{{ $t(group.title) }}</div> -->
                 <el-table class="tableBackgruond" :data="group.data" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
                   <el-table-column :class-name="analysisFlag?'name-col':''" prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                   <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                   <el-table-column :label="$t('device.set')" min-width="160px">
                     <template slot-scope="scope">
                       <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                         popper-class="select-search-recharge">
                         <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
                       </el-select>
                       <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                         <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                           :append-to-body="false"
                           type="datetime"
                           :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                         </el-date-picker>
                       </div>
                       <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                         :placeholder="scope.row.hint"></el-input>
                       <el-input v-model="scope.row.controlvalue" v-else></el-input>
                     </template>
                   </el-table-column>
                   <el-table-column width="200px" :label="$t('device.Operation')">
                     <template slot-scope="scope">
                       <div class="instructieClass">
                         <!-- Obj.value != selectedRadio -->
                         <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                           <i class="iconfont icon-shuaxin"></i>
                           <span>{{$t('device.read') }}</span>
                         </el-button>
                         <!-- Obj.value != selectedRadio :disabled="true" -->
                         <el-button  v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                           <i class="iconfont icon-caozuo_tiaoshi"></i>
                           <span>{{$t('device.distribute') }}</span>
                         </el-button>
                       </div>
                     </template>
                   </el-table-column>
                 </el-table>
               </el-collapse-item >
             </template>
           </el-collapse>

          <!-- <div v-if="tableDataStd.length">
            <div class="tableTitle">{{ $t('createPlant.Standard_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataStd" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataSvs.length">
            <div class="tableTitle">{{ $t('createPlant.System_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataSvs" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataPvs.length">
            <div class="tableTitle">{{ $t('createPlant.Solar_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataPvs" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')" style="background-color: #fff;">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataGrd.length">
            <div class="tableTitle">{{ $t('createPlant.Grid_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataGrd" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')" style="padding: 0;">
                <template slot-scope="scope">
                  <div style="padding: 0;" class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataBat.length">
            <div class="tableTitle">{{ $t('createPlant.Battery_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataBat" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataCts.length">
            <div class="tableTitle">{{ $t('createPlant.Control_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataCts" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataLos.length">
            <div class="tableTitle">{{ $t('createPlant.Load_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataLos" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataBas.length">
            <div class="tableTitle">{{ $t('createPlant.Basic_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataBas" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataAdv.length">
            <div class="tableTitle">{{ $t('createPlant.Advanced_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataAdv" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataElse.length">
            <div class="tableTitle">{{ $t('createPlant.other_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataElse" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div> -->

          <!-- 无数据 -->
          <div v-if="noDataControl">
            <el-table height="50vh" stripe border :empty-text="$t('message.nodata')">
              <el-table-column :label="$t('device.Field_Name')"></el-table-column>
              <el-table-column :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px"></el-table-column>
            </el-table>
          </div>
        </div>
    </control-dialog>

    <!-- 固件升级 -->
    <!-- v-if="upgradeDeviceVisible" -->
    <device-dialog :title="$t('device.device_upgrade')" :visible.sync="upgradeDeviceVisible" :class="{
      showDialog: upgradeDeviceVisible,
      hideDialog: !upgradeDeviceVisible,
    }" width="580px" noFooter>
      <div slot="content">
        <el-form class="grid upload-container upgradeNew">
          <el-form-item :label="$t('device.select_firmware')" size="small">
            <el-select v-model="searchrecharge.firmware" @change="voltageArr($event)"
              :placeholder="$t('device.select_file')" popper-class="select-search-recharge select-search-project">
              <template slot="empty">
                <div style="text-align: right">
                  <button type="button" class="upFirewareBtn" @click="dialogAdd = true">
                    {{ $t("firmware.Upload_firmware") }}
                  </button>
                </div>
              </template>
              <div style="text-align: right">
                <button type="button" class="upFirewareBtn" @click="dialogAdd = true">
                  {{ $t("firmware.Upload_firmware") }}
                </button>
              </div>
              <el-option v-for="item in rechargelist" :key="item.value" :label="item.firmware"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.firmware_type')" size="small">
            <!-- [定制]根据文件名自动选择固件类型disabled -->
            <el-select v-if="!hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
              popper-class="select-search-recharge" ref="autoSelected">
              <el-option v-for="item in firmwaretypelist" :key="item.id" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select v-if="hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
              popper-class="select-search-recharge" ref="autoSelected">
              <el-option v-for="item in firmwaretypelist1" :key="item.id" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.upgrade_brate')" size="small">
            <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')"
              popper-class="select-search-recharge">
              <el-option v-for="item in bratelist" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <div class="processstatueEquipment" v-show="progressUp">
              {{ $t("firmware.upgrading") }}
            </div>
            <div class="processstatueEquipment" v-show="progerssComplete">
              {{ $t("firmware.updateCompleted") }}
            </div>
            <!-- 原上传按钮 -->
            <!-- <div class="upload-contents">
                <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                  <i class="iconfont icon-shangchuan"></i>
                  {{$t('device.Upload')}}
                </button>
                <div class="upload-tip">{{$t('firmware.limit')}}</div>
            </div>-->
            <div class="progressShowEquipment" v-show="progressUp">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <div class="progressCancel" @click="upgradeCancel">
                <i class="iconfont icon-delete"></i>
              </div>
            </div>
            <div class="processDataEquipment" v-show="progressUp">
              <el-progress :format="progressText" :percentage="progress" :stroke-width="10"></el-progress>
              <div class="processBig">
                {{ uploadNowSize }}M / {{ uploadTotalSize }}M
              </div>
            </div>
            <!-- 原上传按钮 -->
            <!-- <input
                type="file"
                class="upload-input"
                ref="fileUploader"
                accept="application/octet-stream"
                @change="uploadfile($event)"
            />-->
            <div class="progerssCompleteEquipment" v-show="progerssComplete">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <div class="progressCancel"></div>
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <button type="button" class="btn btn-dark" @click="submitUpgradeDevice">
            {{ $t("device.confirm") }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <!-- <button
            class="button-hollow"
            @click="upgradeDeviceVisible = false"
        >{{$t('device.cancel')}}</button>-->
        <!-- <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button> -->
      </div>
    </device-dialog>
    <!-- 固件升级二次弹窗（增加固件的对话框） -->
    <!-- style="z-index:2014!important;" -->
    <!-- v-if="dialogAdd" -->
    <!-- :class="{'showDialog': dialogAdd, 'hideDialog': !dialogAdd}" -->
    <update-dialog :title="$t('firmware.Upload_firmware')" v-if="dialogAdd" :visible.sync="dialogAdd" width="40vw"
      noFooter style="z-index: 3000">
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item :label="$t('firmware.Firmware_description')" size="small">
            <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
                <!-- {{$t('datalogger.Upload')}} -->
              </button>
              <div class="upload-tip">
                {{ `${$t("datalogger.Upload")} (${$t("firmware.limit0")})` }}
              </div>
              <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                @change="uploadfile($event)" />
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <button type="button" class="btn btn-dark" @click="dialogAdd = false">
            {{ $t("datalogger.confirm") }}
          </button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </update-dialog>
    <!-- 升级结果提示(成功) -->
    <!-- v-if="upgradeDeviceSucVisible" -->
    <device-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDeviceSucVisible" :class="{
      showDialog: upgradeDeviceSucVisible,
      hideDialog: !upgradeDeviceSucVisible,
    }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- <span class="showresulttext">{{$t('datalogger.modifySuc')}}</span> -->
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="upgradeDeviceSucVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 升级结果提示(失败) -->
    <!-- v-if="upgradeDeviceFailVisible" -->
    <device-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDeviceFailVisible" :class="{
      showDialog: upgradeDeviceFailVisible,
      hideDialog: !upgradeDeviceFailVisible,
    }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="upgradeDeviceFailVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!-- 删除设备 去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="deletingDeviceInfo" -->
    <device-dialog :title="$t('device.deleteDevice')" :visible.sync="deletingDeviceInfo" :class="{
      showDialog: deletingDeviceInfo,
      hideDialog: !deletingDeviceInfo,
    }" width="30vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width: 100%; text-align: left">{{
            $t("device.confirm_deldte")
          }}</span>
        </div>
        <div class="disabledescr">
          <span style="width: 100%; text-align: left; margin-top: 28px">{{
            $t("account.notRecovered")
          }}</span>
        </div>
        <div class="deletfotter" style="text-align: right; margin-top: 28px">
          <button type="button" class="btn btn-dark" style="margin-right: 10px" @click="submitDeleteDevice">
            {{ $t("device.confirm") }}
          </button>
          <button type="button" class="btn btn-light" @click="deletingDeviceInfo = null">
            {{ $t("device.cancel") }}
          </button>
        </div>
      </div>
    </device-dialog>
    <!-- 删除设备结果提示(成功) -->
    <!-- v-if="delDeviceSucVisible" -->
    <device-dialog :title="$t('project.delResults')" :visible.sync="delDeviceSucVisible" :class="{
      showDialog: delDeviceSucVisible,
      hideDialog: !delDeviceSucVisible,
    }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t("project.delSuc") }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="delDeviceSucVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 删除设备结果提示(失败) -->
    <!-- v-if="delDeviceFailVisible" -->
    <device-dialog :title="$t('project.delResults')" :visible.sync="delDeviceFailVisible" :class="{
      showDialog: delDeviceFailVisible,
      hideDialog: !delDeviceFailVisible,
    }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="delDeviceFailVisible = false">
              {{ $t("datalogger.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
  </div>
</template>
<script>
import { mapGetters,mapState } from 'vuex';
import deviceDialog from "@/components/dialognew";
import controlDialog from "@/components/dialognew/controlDialog";
import updateDialog from "@/components/dialognew/flowIndex";
// 导出单个设备报表
import exportPlantDialog from "@/components/dialognew/exportPlant";
//所有设备报表
// import exportPlantDialog from "@/components/dialognew/exportPlantSn";
import clipboard from "@/assets/js/clipboard";
import { i18n } from "@/i18n";
import html2canvas from 'html2canvas'
// import config from "@/assets/js/config";
export default {
  components: {
    deviceDialog,
    exportPlantDialog,
    updateDialog,
    controlDialog,
  },
  data () {
    return {
      analysisFlag:JSON.parse(sessionStorage.getItem('vcodes')||[]).some(item => item === "08"),
      vcodesFlag: false, // 初始false，由监听 vuex vcodes 接收赋值
      activeGroups: [], // 控制折叠面板展开状态
      hasInitializedGroups: false, // ✅ 新增：分组初始化标志
      activeTouGroups: ["1"], // TOU 模式折叠面板展开状态
      selectbtnId:"",
      swichmodesISconfirm:false,//模式切换标识
      oneClickReadFlag:false,//一键读取加载中标识
      oneClickReadTip: false,//一键读取标识
      showOneClickReadBtn: false,//一键读取按钮显示标识
      upgradeDeviceDisabled:false,
      hideFlag: false,//德业域名显隐
      deviceInfoTest: [],
      noDataControl: false,
      emptyText: false,
      paginationControl: false,
      progressUp: false,
      progress: 0,
      search: {
        status: "",
        brand: "",
        pn: "",
        search: "",
      },
      xieyi: [],
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrechargeContents: "", //选择固件时里面的内容
      searchrecharge: {
        firmware: "",
        firmwaretype: "0",
        brate: "0",
      },
      dataparams: "",
      rechargelist: [],
      firmwaretypelist: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
      ],
      firmwaretypelist1: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
        {
          //BMS固件
          id: 15,
          label: this.$t("device.control_firmware_bms"),
          value: "4"
        },
        {
          //SlavMCU固件
          id: 16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5"
        }
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0",
        },
        {
          label: 1200,
          value: "1200",
        },
        {
          label: 2400,
          value: "2400",
        },
        {
          label: 4800,
          value: "4800",
        },
        {
          label: 9600,
          value: "9600",
        },
        {
          label: 19200,
          value: "19200",
        },
        {
          label: 38400,
          value: "38400",
        },
        {
          label: 57600,
          value: "57600",
        },
        {
          label: 115200,
          value: "115200",
        },
      ],
      loadingdevice: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0,
      }, //分页数据
      rangeValue: "0-200",//范围值
      deviceList: [],
      selectedAlarm: [], //批量删除
      controlTableGroups: [
        { key: 'bse', title: 'createPlant.basic_settings', data: [] },
        { key: 'std', title: 'createPlant.Standard_setting', data: [] },
        { key: 'svs', title: 'createPlant.System_settings', data: [] },
        { key: 'pvs', title: 'createPlant.Solar_settings', data: [] },
        { key: 'grd', title: 'createPlant.Grid_settings', data: [] },
        { key: 'bat', title: 'createPlant.Battery_settings', data: [] },
        { key: 'bat1', title: 'createPlant.Battery_settings1', data: [] },
        { key: 'bat2', title: 'createPlant.Battery_settings2', data: [] },
        // { key: 'syo', title: 'createPlant.Work_settings2', data: [] },
        // { key: 'bco', title: 'createPlant.Machine_settings2', data: [] },
        // { key: 'res', title: 'createPlant.Clear_settings2', data: [] },
        { key: 'cts', title: 'createPlant.Control_settings', data: [] },
        { key: 'los', title: 'createPlant.Load_setting', data: [] },
        { key: 'bas', title: 'createPlant.Basic_setting', data: [] },
        { key: 'adv', title: 'createPlant.Advanced_setting', data: [] },
        { key: 'else', title: 'createPlant.other_settings', data: [] },
      ],
      // tableDataHuangJinTai: [], //黄金台定制
      controlinter: [],
      controlvalue: "",
      editDeviceVisible: false,
      editDeviceInfo: null,
      debugDeviceVisible: false,
      debugDeviceId: null,
      upgradeDeviceVisible: false,
      upgradeDeviceterId: null,
      deletingDeviceInfo: null,
      controlDeviceVisible: false,
      statisticDialogVisible: false, //统计弹窗是否可见
      // 编辑设备
      formEdit: {
        sn: "",
        pn: "",
        devaddr: "",
        devcode: "",
        // alias: "",
        devalias: "",
      },
      device: {
        pn: "",
      },
      devDebug: {
        cmd: "",
      },
      debugReturn: "",
      // 是否关注
      followactive: false,
      // 导出报表
      exportPlantParams: [],
      // 显示上传固件二层弹窗
      dialogAdd: false,
      vendorFlag: false,
      desc: "",
      // 修改设备成功提示
      editDeviceSucVisible: false,
      // 修改设备失败提示
      editDeviceFailVisible: false,
      // 删除设备成功提示
      delDeviceSucVisible: false,
      // 删除设备失败提示
      delDeviceFailVisible: false,
      // 升级设备成功提示
      upgradeDeviceSucVisible: false,
      // 升级设备失败提示
      upgradeDeviceFailVisible: false,
      // 操作返回提示
      deviceTipMsg: "",
      // 该设备信息(新)
      deviceOwnInfo: {},
      touFalg: false,
      swichModeVisible: false,
      oldRadioValue: "1",
      selectedRadio: "1", // 单选按钮绑定的值
      touArr: [
        {
          name: this.$t("control.touCharge"),
          items: [],
          value: "1",
          updataTime: this.$filter.formatDate(new Date()),
        },
        {
          name: this.$t("control.touPersonal"),
          items: [],
          value: "2",
          updataTime: this.$filter.formatDate(new Date()),
        },
        {
          name: this.$t("control.touComplete"),
          items: [],
          value: "3",
          updataTime: this.$filter.formatDate(new Date()),
        },
        {
          name: this.$t("control.touClipping"),
          value: "4",
          updataTime: this.$filter.formatDate(new Date()),
          items: [
            {
              id: "swm_tou_grid_feed_pv_cmds",
              name: this.$t("control.pvMode"),
              controlvalue: "",
              item: [
                {
                  key: "0",
                  val: "OFF",
                },
                {
                  key: "100",
                  val: "PV Feed Grid",
                },
                {
                  key: "111",
                  val: "PV+BAT Feed Grid",
                },
              ],
              controlinter: [
                {
                  value: "0",
                  label: "OFF",
                },
                {
                  value: "100",
                  label: "PV Feed Grid",
                },
                {
                  value: "111",
                  label: "PV+BAT Feed Grid",
                },
              ],
            },
            {
              id: "weekday",
              name: "weekday",
              controlvalue: "6",
              item: [
                {
                  key: "0",
                  val: this.$t("control.Monday"),
                },
                {
                  key: "1",
                  val: this.$t("control.Tuesday"),
                },
                {
                  key: "2",
                  val: this.$t("control.Wednesday"),
                },
                {
                  key: "3",
                  val: this.$t("control.Thursday"),
                },
                {
                  key: "4",
                  val: this.$t("control.Friday"),
                },
                {
                  key: "5",
                  val: this.$t("control.Saturday"),
                },
                {
                  key: "6",
                  val: this.$t("control.Sunday"),
                },
              ],
              controlinter: [
                {
                  value: "0",
                  label: this.$t("control.Monday"),
                },
                {
                  value: "1",
                  label: this.$t("control.Tuesday"),
                },
                {
                  value: "2",
                  label: this.$t("control.Wednesday"),
                },
                {
                  value: "3",
                  label: this.$t("control.Thursday"),
                },
                {
                  value: "4",
                  label: this.$t("control.Friday"),
                },
                {
                  value: "5",
                  label: this.$t("control.Saturday"),
                },
                {
                  value: "6",
                  label: this.$t("control.Sunday"),
                },
              ],
            },
            {
              id: "time",
              name: this.$t("control.time"),
              startTime: "00:00",
              endTime: "00:00",
              controlvalue: "",
              data_number: "0",
              effective_control: "",
              showStartPicker: false,
              showEndPicker: false,
              timeTo: false,
              item: [
                {
                  key: "0",
                  val: this.$t("control.charge"),
                },
                {
                  key: "1",
                  val: this.$t("control.discharge"),
                },
              ],
              controlinter: [
                {
                  value: "0",
                  label: this.$t("control.charge"),
                },
                {
                  value: "1",
                  label: this.$t("control.discharge"),
                },
              ],
            },
            {
              id: "time1",
              name: this.$t("control.time1"),
              startTime: "00:00",
              endTime: "00:00",
              controlvalue: "",
              data_number: "1",
              effective_control: "",
              showStartPicker: false,
              showEndPicker: false,
              timeTo: false,
              item: [
                {
                  key: "0",
                  val: this.$t("control.charge"),
                },
                {
                  key: "1",
                  val: this.$t("control.discharge"),
                },
              ],
              controlinter: [
                {
                  value: "0",
                  label: this.$t("control.charge"),
                },
                {
                  value: "1",
                  label: this.$t("control.discharge"),
                },
              ],
            },
            {
              id: "time2",
              name: this.$t("control.time2"),
              startTime: "00:00",
              endTime: "00:00",
              controlvalue: "",
              data_number: "2",
              effective_control: "",
              showStartPicker: false,
              showEndPicker: false,
              timeTo: false,
              item: [
                {
                  key: "0",
                  val: this.$t("control.charge"),
                },
                {
                  key: "1",
                  val: this.$t("control.discharge"),
                },
              ],
              controlinter: [
                {
                  value: "0",
                  label: this.$t("control.charge"),
                },
                {
                  value: "1",
                  label: this.$t("control.discharge"),
                },
              ],
            },
            {
              id: "time3",
              name: this.$t("control.time3"),
              startTime: "00:00",
              endTime: "00:00",
              controlvalue: "",
              data_number: "3",
              effective_control: "",
              showStartPicker: false,
              showEndPicker: false,
              timeTo: false,
              item: [
                {
                  key: "0",
                  val: this.$t("control.charge"),
                },
                {
                  key: "1",
                  val: this.$t("control.discharge"),
                },
              ],
              controlinter: [
                {
                  value: "0",
                  label: this.$t("control.charge"),
                },
                {
                  value: "1",
                  label: this.$t("control.discharge"),
                },
              ],
            },
            {
              id: "time4",
              name: this.$t("control.time4"),
              startTime: "00:00",
              endTime: "00:00",
              controlvalue: "",
              data_number: "4",
              effective_control: "",
              showStartPicker: false,
              showEndPicker: false,
              timeTo: false,
              item: [
                {
                  key: "0",
                  val: this.$t("control.charge"),
                },
                {
                  key: "1",
                  val: this.$t("control.discharge"),
                },
              ],
              controlinter: [
                {
                  value: "0",
                  label: this.$t("control.charge"),
                },
                {
                  value: "1",
                  label: this.$t("control.discharge"),
                },
              ],
            },
            {
              id: "time5",
              name: this.$t("control.time5"),
              startTime: "00:00",
              endTime: "00:00",
              controlvalue: "",
              data_number: "5",
              effective_control: 0,
              showStartPicker: false,
              showEndPicker: false,
              timeTo: false,
              item: [
                {
                  key: "0",
                  val: this.$t("control.charge"),
                },
                {
                  key: "1",
                  val: this.$t("control.discharge"),
                },
              ],
              controlinter: [
                {
                  value: "0",
                  label: this.$t("control.charge"),
                },
                {
                  value: "1",
                  label: this.$t("control.discharge"),
                },
              ],
            }
          ],
          
        },
        {
          name: this.$t("control.touOffgrid"),
          items: [],
          value: "5",
          updataTime: this.$filter.formatDate(new Date()),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo",
      getIsShow: "getIsShow",
    }),
    deviceStatus () {
      // return this.$filter.deviceStatus[this.deviceInfo.status]
      return this.$filter.deviceStatusShadow[this.deviceInfo.status];
    },
             ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  watch: {
        // 监听 vuex 中 vcodes，用 vcodesFlag 接收（包含任一目标编码即为 true）
    "$store.state.user.vcodes": {
      handler (val) {
        if (val && val.length) {
          const codes = ["08", "27",'145']; // 目标厂家编码，可按需追加
          this.vcodesFlag = codes.some(code => val.includes(code));
        }
      },
      immediate: true,
    },
    // 监听切换模式弹框关闭
    swichModeVisible (val) {
      if (!val && !this.swichmodesISconfirm) {
        this.swichModeCencel()
        // controlDeviceVisible
      }
    },
    // 监听控制项弹框，触发其中的日期时间选择器弹框关闭
    controlDeviceVisible (val) {
      if (!val) {
        this.clickClosePicker()
        // controlDeviceVisible
      }
    },
    // deleteDeviceVisible(val) {
    //   if (!val) this.deletingDeviceInfo = null;
    // },
    upgradeDeviceVisible (val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    },
    deviceInfo: {
      handler () {
        this.followactive = this.deviceInfo.focus;
        console.log(this.deviceInfo.focus, "this.deviceInfo.focus");
        
        // this.getDeviceOwnInfo();
      },
      deep: true,
    },
    followactive: {
      handler () {
        this.followactive = this.deviceInfo.focus;
           console.log(this.deviceInfo.focus, "this.deviceInfo.focus12312");
      },
      immediate: true,
    },
    // 响应更新电站列表事件
    "$store.state.event.updateFocus" (val) {
      if (val) {
        this.changeFocus();
        this.$store.state.event.updateFocus = false;
      }
    },
    controlTableGroups: {
      handler (newVal) {
        // 默认展开所有有数据的分组
        if (!this.hasInitializedGroups) {
          this.activeGroups = newVal.filter(g => g.data.length).map(g => g.key);
          this.hasInitializedGroups = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    // this.getDeviceList();
    this.getDeviceOwnInfo();
    this.getQueryCollectorinfoEs();
    this.showHides();
  },
  methods: {
    handleDevaliasInput(val) {
      // this.formEdit.devalias = val.replace(/[^\w\u4e00-\u9fa5]/g, '');
    },
    // 查询设备厂家是否为日月元
    getQueryCollectorinfoEs () {
      let params = {
        action: 'queryCollectorinfoEs',
        pn: this.deviceInfo.pn,
      }
      this.$request.get("queryCollectorinfoEs", params).then(res => {
        if (res.err === 0) {
          if (res.dat.isRRY==1) {
            this.vendorFlag = true
          }else{
            this.vendorFlag = false
          }
        }else{
          this.vendorFlag = false
        }
      })
    },
    // 控制项截图
    screenshot(){
      if (this.swichModeVisible) {
        this.swichModeVisible = false;
      }
      this.$nextTick(() => {
        const content = this.$refs.controlContent;
        html2canvas(content, {
            scale: 2,
            useCORS: true,
            logging: false
        }).then(canvas => {
            this.screenshotUrl = canvas.toDataURL('image/png');
            // 自动下载截图
            const link = document.createElement('a');
            link.download = 'screenshot.png';
            link.href = this.screenshotUrl;
            link.click();
        }).catch(err => {
            console.error('截图失败:', err);
        });
      })
    },
    // 下发日数据
    setOneTimeOfUse(child){
      console.log(this.touArr[3],'this.touArr[3]$$$$$$$$$',child);
      this.selectbtnId = ''
      this.touArr[3].items.forEach((item,ind)=>{
        if(item.data_number){
          let params = {
             pn: this.deviceInfo.pn,
            sn: this.deviceInfo.sn,
            devaddr: this.deviceInfo.devaddr,
            devcode: this.deviceInfo.devcode,
             action:"ctrlTimeOfUseValue",
             i18n:this.$lang.currentLang,
             weekday:child.controlvalue,
             end_time:this.touArr[3].items[ind].endTime.split(":").join(""),
             start_time:this.touArr[3].items[ind].startTime.split(":").join(""),
             effective_control:item.timeTo?"1":"0",
             data_attribute:item.controlvalue,
             data_number:item.data_number,
            }
            this.$set(child, "Loading", true);
            this.$request.get("ctrlTimeOfUseValue", params).then((res) => {
              this.$set(child, "Loading", false);
              if (res.err==0) {
                
              }else if (res.err==1){
                this.$message.error(this.$t("control.setFail"));
              }else{
                this.$message.error(this.$t(`errCode.${res.err}`));
              }
            })
        }
      })
      
    },
    // 下发周数据
    setWeekTimeOfUse(info){
      console.log('同步下发',info);
      
      this.selectbtnId = 'async-weekday'
      let params = { 
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devaddr: this.deviceInfo.devaddr,
        devcode: this.deviceInfo.devcode,
        action:"syncTimeOfUseValue",
        i18n:this.$lang.currentLang,
        weekday:this.touArr[3].items[1].controlvalue,
      };
      this.$set(info, "Loading", true);
      this.$request.get("syncTimeOfUseValue", params).then((res) => {
        console.log('同步下发',info);
        if (res.err==0) {
          this.$message.success(this.$t("datalogger.debugeSucc"));
        }else if (res.err==1){
         this.$message.error(this.$t("control.setFail"));
        }else{
         this.$message.error(this.$t(`errCode.${res.err}`));
        }
        setTimeout(()=>{
          this.$set(info, "Loading", false);
          this.selectbtnId = ''
          console.log('同步下发',info);
        },1000)
      }).catch(err => {
        this.$set(info, "Loading", false);
        this.selectbtnId = ''
        console.error('同步失败:', err);
      });
    },
    // 切换工作模式提交
    swichModeConfirm(){
      let params = {
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devaddr: this.deviceInfo.devaddr,
        devcode: this.deviceInfo.devcode,
        action:"ctrlWorkMode",
        i18n:this.$lang.currentLang,
        work_mode: this.selectedRadio==1?"00":this.selectedRadio==2?"01":this.selectedRadio==3?"02":this.selectedRadio==4?"03":this.selectedRadio==5?"04":"00",
      };
      this.$request.get("webCtrlDevice", params).then((res) => { 
        this.swichModeVisible = false;
        this.swichmodesISconfirm = true;
        if (res.err == 0) { 
          this.oldRadioValue = String(this.selectedRadio) ;
        }else if (res.err==1){
          this.$message.error(this.$t("control.setFail"));
        }else{
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      })
    },
    swichModeCencel(){
      this.swichModeVisible=false
      this.selectedRadio = this.oldRadioValue;
    },
    // 切换工作模式弹窗
    swichMode(val){
      console.log(222,'222',val);
      
      this.swichModeVisible=true
      this.swichmodesISconfirm = false;
    },
    // 查询当前工作模式
    getSystemWorkMode(info) { 
      let params = { 
        pn: info.pn, 
        sn: info.sn, 
        devaddr: info.devaddr, 
        devcode: info.devcode, 
        action:"queryWorkMode",
        i18n:this.$lang.currentLang,
      };
      this.$request.get("queryWorkMode", params).then((res) => {
        if (res.err == 0) {
          this.selectedRadio = String(Number(res.dat)+1);
          this.oldRadioValue = String(Number(res.dat)+1);
        }else{
          
        }
      })
    },
    // 获取系统工作模式
    getArrData(info) {
      let params = {
        pn: info.pn, 
        sn: info.sn, 
        devaddr: info.devaddr, 
        devcode: info.devcode, 
        flag: "swm",
        isEnergyMateH5:1,
        i18n:this.$lang.currentLang,
      };
      this.$request.get("webQueryDeviceCtrlFieldEm", params).then((res) => {
        if (res.err == 0) {
          console.log(res,'res$$$$$$$$$$$');
          
          res.dat.two_tier.cbf.forEach((arr) =>{
            arr.controlvalue=''
            arr.controlinter=[]
            if (arr.item.length>0) {
              arr.item.forEach((item) => {
                // 增
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                arr.controlinter.push({
                  label: item.val,
                  value: item.key,
                });
              });
            }
          })
          res.dat.two_tier.su.forEach((arr) =>{
            arr.controlvalue=''
            arr.controlinter=[]
            if (arr.item.length>0) {
              arr.item.forEach((item) => {
                // 增
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                arr.controlinter.push({
                  label: item.val,
                  value: item.key,
                });
              });
            }
          })
          res.dat.two_tier.fg.forEach((arr) =>{
            arr.controlvalue=''
            arr.controlinter=[]
            if (arr.item.length>0) {
              arr.item.forEach((item) => {
                // 增
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                arr.controlinter.push({
                  label: item.val,
                  value: item.key,
                });
              });
            }
          })
          res.dat.two_tier.og.forEach((arr) =>{
            arr.controlvalue=''
            arr.controlinter=[]
            if (arr.item.length>0) {
              arr.item.forEach((item) => {
                // 增
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                arr.controlinter.push({
                  label: item.val,
                  value: item.key,
                });
              });
            }
          })
          this.touArr[0].items = res.dat.two_tier.cbf;
          this.touArr[1].items = res.dat.two_tier.su;
          this.touArr[2].items = res.dat.two_tier.fg;
          this.touArr[4].items = res.dat.two_tier.og;
          // this.getCacheData()
          console.log(this.touArr,'this.touArr###############');
          this.touFalg=true
        }
      });
    },
    // 控制项操作处理
    OperationStyle({row,column,rowIndex,columnIndex}){
      if (columnIndex==3) {
        return "background:#222d35;"
      }
    },
    //德业域名
    showHides () {
      var hostname = window.location.hostname;
      if (hostname == "deye.dessmonitor.com") {
        this.hideFlag = true
      }
    },
    changeFocus () {
      this.$set(this.deviceInfo, "focus", !this.deviceInfo.focus);
      this.followactive = this.deviceInfo.focus;
    },
    // 关注 (info)
    // pn/sn/devaddr/devcode/focus(true,false)
    followDevice (info) {
      // this.focus = !this.focus;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        // focus: info.focus == undefined ? false : deviceInfo.focus,
        focus: !info.focus,
      };
      // console.log('关注param', param);
      this.$request.get("editDeviceFocusEs", param).then((res) => {
        if (res.err === 0) {
          // this.followactive = param.focus;
          // console.log('关注成功followactive', this.followactive);
          // this.deviceInfo.focus = !info.focus;
          this.$set(this.deviceInfo, "focus", info.focus);
          this.followactive = this.deviceInfo.focus;
          this.$store.commit("saveDeviceInfo", {
            pn: info.pn,
            sn: info.sn,
            deviceSn: info.deviceSn || info.sn,
            devalias: info.devalias,
            devcode: info.devcode,
            devaddr: info.devaddr,
            status: info.status,
            focus: !info.focus,
            profitToday: info.profitToday,
            profitTotal: info.profitTotal,
            sellProfitToday: info.sellProfitToday,
            sellProfitTotal: info.sellProfitTotal,
            buyProfitToday: info.buyProfitToday,
            buyProfitTotal: info.buyProfitTotal,
            otaLabel: info.otaLabel,
            // pid: deviceInfo.pid,
          });
          // 通知项目列表更新
          this.$store.state.event.updateProjectList = true;
        } else {
          // console.log('关注失败', res.err);
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 导出报表
    // exportDevice() {},
    exportPlant (exportPlantParams) {
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },
    progressText (progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    //获取表格数据
    // getDeviceList(reset) {
    //   this.paginationControl = false;
    //   if (reset) this.pagination.currentPage = 1;
    //   let param = {
    //     ...this.search,
    //     devtype: 2304,
    //     page: this.pagination.currentPage - 1,
    //     pagesize: this.pagination.pagesize
    //   };
    //   this.loadingdevice = true;
    //   this.$request.get("webQueryDeviceEs", param).then(res => {
    //     if (res.err == 0) {
    //       this.deviceList = res.dat.device;
    //       this.pagination.total = res.dat.total;
    //       if (this.pagination.total > this.pagination.pagesize) {
    //         this.paginationControl = true;
    //       }
    //     } else {
    //       // this.$message.warning(this.$t(`errCode.${res.err}`));
    //       this.emptyText = true;
    //       this.deviceList = [];
    //       this.pagination.total = 0;
    //     }
    //     this.loadingdevice = false;
    //   });
    // },
    // 获取设备信息
    getDeviceOwnInfo () {
      let param = {
        sn: this.deviceInfo.sn,
        // devtype: 2304,
      };
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then((res) => {
        if (res.code == 0) {
          // 新接口返回值转换为旧接口设备列表结构
          this.deviceOwnInfo = this.Fnreturndev(res)[0] || {};
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 点击进入设备
    // enterDevice(info) {
    //   this.$store.commit("saveDeviceInfo", {
    //     pn: info.pn,
    //     sn: info.sn,
    //     devcode: info.devcode,
    //     devaddr: info.devaddr,
    //     devalias: info.alias
    //   });
    // },
    // 编辑设备
    editDevice (info) {
      this.editDeviceVisible = true;
      this.formEdit = { ...info, devalias: info.devalias };
    },
    // 确定修改逆变器
    submitEditDevice () {
      let param = {
        pn: this.formEdit.pn,
        sn: this.formEdit.sn,
        devaddr: this.formEdit.devaddr,
        devcode: this.formEdit.devcode,
        alias: this.formEdit.devalias,
      };
      this.$request.get("editDeviceInfo", param).then((res) => {
        if (res.err == 0) {
          // this.$message.success(this.$t("device.modifySuc"));
          this.editDeviceVisible = false;
          this.editDeviceSucVisible = true;
          window.location.reload();
          this.formEdit = {};
          // 通知设备列表更新
          this.$store.state.event.updateDeviceList = true;
          // this.getDeviceList();
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.deviceTipMsg = this.$t(`errCode.${res.err}`);
          this.editDeviceFailVisible = true;
        }
      });
    },
    // 调试设备
    debugDevice (info) {
      this.$store.commit('saveIsShow', 5);
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        status: info.status,
        descx: info.descx,
        load: info.load,
        edate: info.edate,
        brand: info.brand,
        devalias: info.alias,
        collalias: info.calias,
        signal: info.signal,
        usr: info.usr,
        device_Firmware_Version: info.fireware,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
        otaLabel: info.otaLabel,
      });
    },
    // 调试清空
    qingkong () {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi (event) {
      clipboard(this.debugReturn, event);
    },
    // 发送指令
    submitDebugDevice () {
      if (this.device.status == "1") {
        this.$message.error(this.$t("device.Debugfail"));
      } else {
        this.debugReturn = this.$t("device.instruction_response");
        let param = {
          pn: this.device.pn,
          devaddr: this.device.devaddr,
          cmd: this.devDebug.cmd,
        };
        this.$request.get("sendCmdToDevice", param).then((res) => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.debug_suc"));
            this.debugReturn = res.dat.dat;
            // this.debugDeviceVisible = false;
            // this.getDeviceList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 控制项日期时间选择窗口关闭处理
    clickClosePicker(){
      if (this.$refs['controlDatepickerRef-system_time']) {
        this.$refs['controlDatepickerRef-system_time'].hidePicker()
      }
      if (this.$refs['controlDatepickerRef-sys_system_time']) {
        this.$refs['controlDatepickerRef-sys_system_time'].hidePicker()
      }
    },
    // 日月元6629一键读取
    async oneClickRead() {
      console.log('一键读取');
      this.oneClickReadFlag = true;
      this.oneClickReadTip = true;
      // 依次读取每个分组下每个item，控制项弹窗关闭则结束接口调用
      for (const group of this.controlTableGroups) {
        for (const item of group.data) {
          if (!this.controlDeviceVisible) {
            this.oneClickReadFlag = false;
            this.oneClickReadTip = false;
            return;
          }
          await this.readItem(item);
        }
      }
      this.oneClickReadFlag = false;
      this.oneClickReadTip = false;
    },
    // 封装单个item读取，返回Promise
    readItem(item) {
      return new Promise((resolve) => {
        // huoquInverter方法本身是异步的，但没有返回Promise，需要手动处理
        // 修改huoquInverter，增加回调参数
        this.huoquInverter(item, resolve);
      });
    },
    // 控制项
    controlDevice (info) {
      this.controlDeviceVisible = true;
      this.hasInitializedGroups = false; 
      this.controlDeviceVisible = true;
      if (this.deviceInfo.devcode=='6596'||this.deviceInfo.devcode=='6445'||this.deviceInfo.devcode=='6573'||this.deviceInfo.devcode=='6642'||this.deviceInfo.devcode=='6626'||this.deviceInfo.devcode=='6638'||this.deviceInfo.devcode=='6629'||this.deviceInfo.devcode=='6462'||this.deviceInfo.devcode=='6605') {
        this.getArrData(info)
        this.getSystemWorkMode(info)
        this.touFalg=false
      }
      this.noDataControl = false;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      i18n: this.$lang.currentLang,
             role:1,
        accountType:this.$store.state.user.role == 0? 3 : this.$store.state.user.role,
        userId:this.$store.state.user.uidExtra
      };
      this.controlparams = info;
       let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceCtrlStrategy" : "queryDeviceCtrlField";
      this.$request[this.method](url, param).then((res) => {
        if (res.err == 0) {
          let tableData = res.dat.field;
          // 定义分组key顺序
          let groupKeys = ['bse','std','svs','pvs','grd','bat','bat1','bat2','cts','los','bas','adv','else'];
          // 若为6629，插入bat1和bat2到bat后面，并将svs移到最后
          // 设置一键读取按钮显示标识
          // ||info.devcode == 6638||info.devcode == 6445||info.devcode == 6596
          this.showOneClickReadBtn = (info.devcode == 6629);
          if (info.devcode == 6629) {
            const svsIdx = groupKeys.indexOf('svs');
            if (svsIdx !== -1) {
              const svsKey = groupKeys.splice(svsIdx, 1)[0];
              groupKeys.push(svsKey);
            }
          }
          // 用对象收集各分组
          const tempGroupsObj = {};
          groupKeys.forEach(key => tempGroupsObj[key] = []);
          tableData.forEach((field) => {
            field.controlinter = [];
            if (field.item) {
              field.item.forEach((item) => {
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                field.controlinter.push({
                  label: item.val,
                  value: item.key,
                });
              });
              field.controlvalue = "";
            }
            var s = field.id;
            if (s.startsWith("bse_")) {
              tempGroupsObj['bse'].push(field);
            } else if (s.startsWith("std_")) {
              tempGroupsObj['std'].push(field);
            } else if (s.startsWith("sys_")) {
              tempGroupsObj['svs'].push(field);
            } else if (s.startsWith("pvs_")) {
              tempGroupsObj['pvs'].push(field);
            } else if (s.startsWith("grd_")) {
              tempGroupsObj['grd'].push(field);
            } else if (s.startsWith("bat_")) {
              tempGroupsObj['bat'].push(field);
            } else if ((info.devcode == 6629||info.devcode == 6605) && s.startsWith("bat1_")) {
              tempGroupsObj['bat1'].push(field);
            } else if ((info.devcode == 6629||info.devcode == 6605) && s.startsWith("bat2_")) {
              tempGroupsObj['bat2'].push(field);
            // } else if ((info.devcode == 6629||info.devcode == 6638) && s.startsWith("syo_")) {
            //   tempGroupsObj['syo'].push(field);
            // } else if ((info.devcode == 6629||info.devcode == 6638) && s.startsWith("bco_")) {
            //   tempGroupsObj['bco'].push(field);
            // } else if ((info.devcode == 6629||info.devcode == 6638) && s.startsWith("res_")) {
            //   tempGroupsObj['res'].push(field);
            } else if (s.startsWith("cts_")) {
              tempGroupsObj['cts'].push(field);
            } else if (s.startsWith("los_")) {
              tempGroupsObj['los'].push(field);
            } else if (s.startsWith("bas_")) {
              tempGroupsObj['bas'].push(field);
            } else if (s.startsWith("adv_")) {
              tempGroupsObj['adv'].push(field);
            } else {
              tempGroupsObj['else'].push(field);
            }
          });
          // 按当前controlTableGroups顺序，重新排序为groupKeys顺序
          this.controlTableGroups = groupKeys.map(key => {
            let group = this.controlTableGroups.find(g => g.key === key);
            if (!group) {
              group = { key, title: '', data: [] };
            }
            // bat分组title动态设置
            if (key === 'bat') {
              const title = (info.devcode == 6629||info.devcode == 6605) ? 'createPlant.Battery_settingsTT' : 'createPlant.Battery_settings';
              return { ...group, title, data: tempGroupsObj[key] };
            }
            return { ...group, data: tempGroupsObj[key] };
          });
          console.log('controlTableGroups', this.controlTableGroups);
        } else {
          this.noDataControl = true;
          this.controlTableGroups.forEach(group => group.data = []);
        }
      });
      // //黄金台设备调用下方黄金台定制funtcion
      // if (info.devcode == 2384) {
      //   this.getHuangjintaiControl(info);
      // } else if (info.devcode == 2366) {
      //   this.getHuangjintaiControl(info);
      // } else {
      //   this.tableDataHuangJinTai = [];
      // }
    },
    // //黄金台定制,获取电池电压和倍率
    // getHuangjintaiControl (info) {
    //   let param = {
    //     pn: info.pn,
    //     sn: info.sn,
    //     devcode: info.devcode,
    //     devaddr: info.devaddr,
    //   };
    //   this.$request.get("queryCtrlHuangJinTaiView", param).then((res) => {
    //     if (res.err == 0) {
    //       this.tableDataHuangJinTai = [];
    //       this.tableDataHuangJinTai.push({
    //         voltage: res.dat.voltage,
    //         multiply: res.dat.multiply,
    //       });
    //     } else if (res.err == 8) {
    //       this.tableDataHuangJinTai = [];
    //       this.tableDataHuangJinTai.push({
    //         voltage: 12,
    //         multiply: 0.09,
    //       });
    //     } else {
    //       this.tableDataHuangJinTai = [];
    //     }
    //   });
    // },
    // huangjintaiChange (val) {
    //   var volArr = [
    //     { key: "12V", val: 12 },
    //     { key: "24V", val: 24 },
    //     { key: "48V", val: 48 },
    //     { key: "96V", val: 96 },
    //   ];
    //   var mulArr = [
    //     { key: "0.09", val: 0.09 },
    //     { key: "0.18", val: 0.18 },
    //     { key: "0.36", val: 0.36 },
    //     { key: "0.72", val: 0.72 },
    //   ];
    //   volArr.forEach((element, index) => {
    //     if (element.val == val) {
    //       this.tableDataHuangJinTai[0].multiply = mulArr[index].val;
    //     }
    //   });
    // },
    // 控制项获取当前值，支持回调
    huoquInverter (info, callback) {
      console.log('点击了读取',info,callback);
      
      if (info.id=='weekday'&&(this.deviceInfo.devcode=='6605'||this.deviceInfo.devcode=='6596'||this.deviceInfo.devcode=='6629'||this.deviceInfo.devcode=='6638'||this.deviceInfo.devcode=='6445')) {
        this.selectbtnId = ''
        let params = { 
          pn: this.deviceInfo.pn,
          sn: this.deviceInfo.sn,
          devaddr: this.deviceInfo.devaddr,
          devcode: this.deviceInfo.devcode,
          action: "queryTimeOfUseValue",
          weekday: this.touArr[3].items[1].controlvalue,
          i18n:this.$lang.currentLang,
        }
         this.$set(info, "isLoading", true);
        this.$request.get("queryTimeOfUseValue", params).then((res) => {
           this.$set(info, "isLoading", false);
          if (res.err == 0) {
            res.dat.forEach((item,index) => {
              item.end_time=item.end_time.substring(0, 2) + ":" + item.end_time.substring(2);
              item.start_time=item.start_time.substring(0, 2) + ":" + item.start_time.substring(2);
              this.touArr[3].items[index+2].startTime=item.start_time;
              this.touArr[3].items[index+2].endTime=item.end_time;
              this.touArr[3].items[index+2].controlvalue=item.data_attribute;
              this.touArr[3].items[index+2].timeTo=item.effective_control==1?true:false;
            })
          }else if (res.err==1){
            this.$message.error(this.$t("control.readFail"));
          }else{
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        })
      }else{
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          i18n: this.$lang.currentLang,
        };
        this.$set(info, "isLoading", true);
        // 微服务且一键读取时才走 queryCtrlFieldKey，单条读取仍用原接口；请求方式随接口同步
        let useMicroCtrl = this.isMicroService && this.oneClickReadTip;
        let url = useMicroCtrl ? "/ppe/api/auth/web/queryCtrlFieldKey" : "queryDeviceCtrlValue";
        this.$request[useMicroCtrl ? this.method : "get"](url, param).then((res) => {
          if (res.err == 0) {
            if (res.dat.val == "undefined" || res.dat.val == "null") {
              res.dat.val = "--";
            }
            if(info.controlinter.length){
              info.controlinter.forEach((item) => {
                if (item.label == res.dat.val) {
                  this.$set(info, 'controlvalue', item.value)
                }else if(item.label.toString().toLowerCase() == res.dat.val.toString().toLowerCase()){
                  this.$set(info, 'controlvalue', item.value)
                }
              });
              if(!info.controlvalue)
                this.$set(info, 'controlvalue', res.dat.val || this.$t("nodata"))
            }else{
              this.$set(info, 'controlvalue', res.dat.val || this.$t("nodata"))
            }
          } else {
            if (this.oneClickReadTip) {
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          }
          this.$set(info, "isLoading", false);
          if (callback) callback();
        }).catch(() => {
          this.$set(info, "isLoading", false);
            if (this.oneClickReadTip) {
            } else {
              this.$message.error(this.$t(`errCode.3`));
            }
          if (callback) callback();
        });
      }
    },
    // 下发指令(黄金台)
    xiafaInverterHuangJinTai (info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        voltage: info.voltage,
        multiply: info.multiply,
      };
      // info.Loading = true;
      this.$set(info, "Loading", true);
      this.$request.get("ctrlHuangJinTaiView", param).then((res) => {
        if (res.err == 0) {
          this.$message.success(this.$t("device.Send_suc"));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.Loading = false;
        this.$set(info, "Loading", false);
      });
    },
    // 下发指令
    xiafaInverter (info) {
      console.log('下发指令',info);
      this.selectbtnId = ''
      if (!info.controlvalue) {
        this.$message.error(this.$t("device.Send_Input"));
      } else {
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          val: info.controlvalue,
          i18n: this.$lang.currentLang,
        };
        this.$set(info, "Loading", true);
        // info.Loading = true;
        this.$request.get("ctrlDevice", param).then((res) => {
          // this.$request.get("ctrlDevice", param).then(res => {
          if (res.err == 0) {
            if (this.controlparams.devcode == 2352) {
              var medium = res.dat.dat.substring(27, 29);
              if (medium == "31") {
                this.$message.success(this.$t("device.Send_suc"));
              } else {
                this.$message.error(this.$t("device.Send_fail"));
              }
            } else {
              this.$message.success(this.$t("device.Send_suc"));
            }
            // if(this.controlparams.devcode == '6605'&&info.id=='bat_parallel'){
            //   this.controlDeviceVisible=false
            //   this.$message.warning(this.$t('device.batteryParallelTip'))
            // }
          } else {
            if (this.controlparams.devcode == 2376) {
              if (res.desc.match(/\(([^)]*)\)/)) {
                this.$message.error(res.desc.match(/\(([^)]*)\)/)[1]);
              } else {
                // 获取错误提示，如果没有匹配到则使用默认提示
                const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
                this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
              }
            } else {
              // 获取错误提示，如果没有匹配到则使用默认提示
              const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
              this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
            }
            // this.$message.error(this.$t(`errCode.${res.err}`));
          }
          // info.Loading = false;
          this.$set(info, "Loading", false);
        }).catch(() => {
          this.$set(info, "Loading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
      }
    },
    voltageArr (item) {
      this.rechargelist.forEach((element) => {
        if (element.id == item) {
          this.searchrechargeContents = element;
        }
      });
    },
    // 设备固件升级
    upgradeDevice (info) {
      // console.log(info,'info');
      this.upgradeDeviceDisabled = true;
      this.$request.getUPG(`/upg/api/auth/web/device/upgradeType/${info.devcode}`).then(res=>{
        if(res.code == 0){
         if(res.data.items && res.data.items.length != 0){
          this.$store.commit('saveUpgradeUPG', true);
          this.$store.commit('saveUpgradeUPGItems', res.data.items);
          this.$store.commit('saveIsShow', 7);
          this.$store.state.event.foldGeneralSidebarNew = true;
          this.upgradeDeviceDisabled = false;
         }else{
          this.$store.commit('saveUpgradeUPG', false);
          // this.$store.commit('saveIsShow', 2);
          // this.$request.get(`queryDevUpMode`,{pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr,}).then(res=>{
          this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr}).then(res=>{
             if(res.code == 0){
              if(res.data ==1){
                this.$store.commit('saveUpgradeTypeUPG', true);
                this.$store.commit('saveIsShow', 8);
              }else{
                this.$store.commit('saveUpgradeTypeUPG', false);
                this.$store.commit('saveIsShow', 2);
              }
             }else{
               this.$store.commit('saveIsShow', 2);
               this.$store.commit('saveUpgradeTypeUPG', false);
             }
             this.$store.state.event.foldGeneralSidebarNew = true;
             this.upgradeDeviceDisabled = false;
           }).catch(() => {
            this.$store.commit('saveIsShow', 2);
            this.$store.commit('saveUpgradeTypeUPG', false);
            this.$store.state.event.foldGeneralSidebarNew = true;
            this.upgradeDeviceDisabled = false;
            })
         }
        }else{
            this.$store.commit('saveUpgradeUPG', false);
            // this.$request.get(`queryDevUpMode`,{pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr,}).then(res=>{
            this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr}).then(res=>{
             if(res.code == 0){
              if(res.data ==1){
                this.$store.commit('saveUpgradeTypeUPG', true);
                this.$store.commit('saveIsShow', 8);
              }else{
                this.$store.commit('saveUpgradeTypeUPG', false);
                this.$store.commit('saveIsShow', 2);
              }
             }else{
               this.$store.commit('saveIsShow', 2);
               this.$store.commit('saveUpgradeTypeUPG', false);
             }
             this.$store.state.event.foldGeneralSidebarNew = true;
             this.upgradeDeviceDisabled = false;
           }).catch(() => {
            this.$store.commit('saveIsShow', 2);
            this.$store.commit('saveUpgradeTypeUPG', false);
            this.$store.state.event.foldGeneralSidebarNew = true;
            this.upgradeDeviceDisabled = false;
          })
        }
      }).catch(() => {
        this.$store.commit('saveIsShow', 2);
        this.$store.commit('saveUpgradeTypeUPG', false);
        this.$store.state.event.foldGeneralSidebarNew = true;
        this.upgradeDeviceDisabled = false;
        })
      // console.log("upgrade-info", info);
      // this.queryFirmware();
      // this.upgradeDeviceVisible = true;
      // this.dataparams = info;
      // this.progerssComplete = false;
      // this.$store.state.event.foldGeneralSidebarNew = true;

    },
    // 查询固件列表
    queryFirmware () {
      this.searchrecharge.firmware = null;
      this.rechargelist = [];
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { pagesize: 50 }).then((res) => {
        if (res.code == 0) {
          res.data.items.forEach((item) => {
            this.rechargelist.push({
              id: item.id,
              firmware: item.firmware,
              size: item.size,
            });
          });
        }
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("device.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex"&& suffix !== "S19") {
        this.$message.error(this.$t("device.error1"));
        return;
      }

      // [定制(根据文件名自动选择下拉固件类型)]
      // 截取文件后缀获取文件名
      // let reg = /\.\w+$/;
      // let getFileName = file.name.replace(reg,'');

      this.$request.uploadfileAxios(file).then((res) => {
        if (res.code === 0) {
          this.$message.success(this.$t("device.uploadSuccess"));
          // this.upgradeDeviceVisible = false;
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("device.error1"));
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
          // 关闭二次弹窗
          this.dialogAdd = false;
        }
        this.queryFirmware();
        // this.upgradeDeviceVisible = false;
      });
    },
    // 确认固件升级
    submitUpgradeDevice () {
      // console.log("this.searchrechargeContents", this.searchrechargeContents);
      this.progress = 0;
      if (!this.searchrecharge.firmware) {
        this.$message.error(this.$t("device.file_fist"));
      } else if (this.dataparams.status == "1") {
        this.$message.error(this.$t("device.updatefail"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          pn: this.dataparams.pn,
          devaddr: this.dataparams.devaddr,
          devcode: this.dataparams.devcode,
          sn: this.dataparams.sn,
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate,
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/device/upgrade/firmwareUpgradeDevice", params).then((res) => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              // this.$message.success(this.$t("device.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));

              // this.deviceTipMsg = this.$t("device.Upgrading");
              // this.upgradeDeviceSucVisible  = true;
              this.queryProgress();

              // this.upgradeDeviceVisible = false;
              // this.dialogAdd = false;
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              // this.deviceTipMsg = this.$t("device.System_Failed");
              // this.upgradeDeviceFailVisible = true;
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              // this.deviceTipMsg = this.$t("device.Device_Offline");
              // this.upgradeDeviceFailVisible = true;
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              // this.deviceTipMsg = this.$t("device.In_Upgrading");
              // this.upgradeDeviceFailVisible = true;
            }
            // this.upgradeDeviceVisible = false;
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            // this.deviceTipMsg = this.$t(`errCode.${res.code}`);
            // this.upgradeDeviceFailVisible = true;
          }
        });
      }
    },
    // 查询升级进度
    queryProgress () {
      this.progressUp = true;
      this.progerssComplete = false;
      let params = {
        pn: this.dataparams.pn,
        devaddr: this.dataparams.devaddr,
        devcode: this.dataparams.devcode,
        sn: this.dataparams.sn,
        key: this.keyProgress,
      };
      // 如果已存在定时器，先清除
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeProgress", params)
          .then((res) => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                // this.progressText = progress + "%";
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  clearInterval(this.interval);
                  this.interval = null;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.$message.success(this.$t("device.Update_Completed"));
                  setTimeout(() => {
                    this.upgradeDeviceVisible = false;
                  }, 2000);
                  return;
                }
              } else if (res.data.status == 1) {
                this.$message.error(this.$t("firmware.upgrade_quit1"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 2) {
                this.$message.error(this.$t("firmware.upgrade_quit2"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 3) {
                this.$message.error(this.$t("firmware.upgrade_quit3"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 4) {
                this.$message.error(this.$t("firmware.upgrade_quit4"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 5) {
                this.$message.error(this.$t("firmware.upgrade_quit5"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              }
            } else {
              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              clearInterval(this.interval);
              this.interval = null;
            }
          });
      }, 2000);
    },
    //取消升级
    upgradeCancel () {
      this.$request.putUPG("/upg/api/auth/web/shineDess/device/upgrade/deviceCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress,
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
    },
    deleteDevice (info) {
      this.deletingDeviceInfo = {
        pn: info.pn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        sn: info.sn,
      };
    },
    // 确定删除设备
    submitDeleteDevice () {
      this.$request
        .get("delDeviceFromPlant", this.deletingDeviceInfo)
        .then((res) => {
          if (res.err == 0) {
            // this.$message.success(this.$t("device.deleteSuc"));
            this.deletingDeviceInfo = null;
            this.delDeviceSucVisible = true;
            // this.getDeviceList();
            this.$store.state.event.updateProjectList = true;
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.deviceTipMsg = this.$t(`errCode.${res.err}`);
            this.delDeviceFailVisible = true;
          }
       
        });
    },
    //勾选多项
    changeFun (val) {
      this.selectedAlarm = val; // 返回的是选中的列的数组集合
    },
    // 给下发指令该列增加样式
    // (row, column, rowIndex, columnIndex)
    changeCellStyle (row) {
      if (row.column.label == i18n.t("device.Send_Command")) {
        return "background: linear-gradient(0deg, rgba(60, 75, 87, 1) 5.36%, rgba(42, 54, 63, 1) 100%);box-shadow: -1px -1px 11px rgba(74, 74, 74, 0.06), 0px 4px 4px rgba(0, 0, 0, 0.25);";
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.deviceoperateNew {
  /deep/ .el-table__body .name-col .cell {
    text-align: left !important;
  }
  /deep/.el-collapse-item__wrap{
    background: #222d35;
    border: none;
  }
  /deep/.el-collapse{
    border: none;
  }
  /deep/.el-collapse-item__content{
    background: #222d35;
  }
  /deep/.el-collapse-item__header{
    background: #222d35;
    color: #fff;
    border: none;
  }
  .instructieClass{
    display: flex;
    max-width: 300px;
  }
  padding: 8px 30px 8px 10px;
  display: flex;
  // margin-bottom: 10px;
  justify-content: space-between;
  align-items: center;
  background: rgb(34, 45, 53);
  color: #ffffff;

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .top-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    max-width: 30%;

    .label {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      .sc(14px, #333);

      // 设备状态带阴影
      .status-icon-shadow {
        width: 14px;
        height: 14px;
        border-radius: 7px;
        margin: 0 14px 0 18px;
      }

      .status-normal-shadow {
        background-color: rgba(48, 236, 112, 1);
        box-shadow: 1px 1px 3px rgba(48, 236, 112, 1);
      }

      .status-offline-shadow {
        background-color: rgba(183, 183, 183, 1);
        box-shadow: 1px 1px 3px rgba(183, 183, 183, 1);
      }

      .status-fault-shadow {
        background-color: rgba(255, 62, 62, 1);
        box-shadow: 1px 1px 3px rgba(255, 62, 62, 1);
      }

      .status-standby-shadow {
        background-color: rgba(73, 222, 255, 1);
        box-shadow: 1px 1px 3px rgba(73, 222, 255, 1);
      }

      .status-warning-shadow {
        background-color: rgba(236, 150, 48, 1);
        box-shadow: 1px 1px 3px rgba(236, 150, 48, 1);
      }
    }

    .namebox {
      // display: block;
      // text-align: left;
      max-width: 100%;

      .name {
        display: inline-block;
        width: 100%;
        font-family: Microsoft YaHei;
        font-size: 20px;
        font-weight: bold;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .ico-edit {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url(../../../../assets/img/general/Icon_Pencil.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }
  }

  .top-operate {
    .operation {
      // width: 86px;
      // height: 32px;
      padding: 6px 12px;
      border-radius: 6px;
      border: 1px solid rgba(85, 180, 145, 1);
      box-sizing: border-box;
      background-color: @primaryButtonColor;
      color: #ffffff;

      i {
        font-size: 18px;
        vertical-align: middle;
      }

      .icon-text1 {
        display: inline-block;
        margin-left: 6px;
      }

      // 是否关注
      .followno {
        background-image: url(../../../../assets/img/general/Icon_Operate_Follow_Light.png);
        background-size: contain;
      }

      .followyes {
        background-image: url(../../../../assets/img/general/Icon_Operate_Follow_Dark.png);
        background-size: 22px 22px;
      }

      .ico-export {
        background-image: url(../../../../assets/img/general/Icon_Operate_Export.png);
      }

      .ico-debug {
        background-image: url(../../../../assets/img/general/Icon_Operate_Debug.png);
      }

      .ico-control {
        background-image: url(../../../../assets/img/general/Icon_Operate_Control.png);
      }

      .ico-upgrade {
        background-image: url(../../../../assets/img/general/Icon_Operate_Upgrade.png);
      }

      .ico-delete {
        background-image: url(../../../../assets/img/general/Icon_Operate_Delete.png);
      }

      .icobase {
        width: 18px;
        height: 18px;
        display: inline-block;
        background-position: center;
        background-repeat: no-repeat;
        // background-size: contain;
        vertical-align: middle;
      }
    }

    .delBgc {
      border: 1px solid rgba(255, 62, 62, 1);
      background: rgba(255, 62, 62, 0.5);
      color: #ffffff;
    }
  }

  .gOperate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: row;

    .gRowOne {
      margin-right: 10px;
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
  // 控制弹框
  .control {
    /deep/ .el-input__prefix{
      display: none !important;
    }
    .custom-radio {
      /deep/ .el-radio__input.is-checked .el-radio__inner {
        border-color: var(--primaryTextColor, #30D096);
        background: var(--primaryTextColor, #30D096) ;
      }

      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #fff;
      }
      /deep/ .el-radio__label {
        color: #ffffff; // 未选中时字体为白色
      }

    }
    
  /deep/ .el-checkbox .el-checkbox__input .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #30D096 !important;
    border-color: #30D096 !important;
  }
  /deep/ .el-checkbox .el-checkbox__input .el-checkbox__inner:hover,
  .el-checkbox .el-checkbox__input .el-checkbox__inner:focus {
    border: 1px solid rgba(235, 235, 235, 1);
    background: transparent;
  }

  /deep/ .el-checkbox .el-checkbox__label {
    font-size: 14px;
    color: rgba(235, 235, 235, 1);
  }

  /deep/ .el-checkbox .el-checkbox__input.is-checked+.el-checkbox__label {
    color: rgba(235, 235, 235, 1);
  }

  /deep/ .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    // background: @primaryTextColor;
    // border-color: @primaryTextColor;
    background: transparent;
    border-color: rgba(235, 235, 235, 1);
  }

  /deep/ .el-checkbox .el-checkbox__input .el-checkbox__inner::after {
    top: 2px;
    left: 5px;
  }
    .tableBackgruond{
      background-color: #222d35
    }
    .current-value {
      display: flex;

      .el-input {
        flex: 1;
        margin-right: 3px;
      }

      .submit-control {
        i {
          font-size: 16px;
        }

        padding: 5px 12px;
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: rgba(255, 255, 255, 1);
      }
    }

    .control-value {
      .submit-control {
        i {
          font-size: 18px;
        }
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: @primaryTextColor;
      }
    }

    /deep/.el-input .el-input__inner {
      border: none;
    }

    /deep/.el-table th,
    /deep/.el-table tr {
      background: rgba(34, 45, 53, 1);
      color: #ffffff;
      padding: 0px 10px;
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
      border: none;
    }

    // /deep/.el-button,
    // /deep/.el-button:focus,
    // /deep/.el-button:hover {
    // 	background: transparent;
    // 	border: none;
    // 	color: @primaryTextColor;
    // }
    // 表头
    /deep/.el-table th {
      border: none;
      box-shadow: 0px 1px rgba(255, 255, 255, 0.25) inset,
        0px -1px rgba(255, 255, 255, 0.25) inset;
    }

    /deep/.el-table--border,
    /deep/.el-table--group {
      border: none;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    // 间距
    /deep/ .el-table__body {
      border-collapse: separate;
      border-spacing: 10px;
      table-layout: auto !important;
      background: rgba(34, 45, 53, 1);
    }
  }

  .el-table--border::after,
  .el-table--group::after {
    width: 0px;
  }

  .tableloding {

    // 加载数据时遮罩
    /deep/.el-loading-mask {
      background-color: transparent;
    }

    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor !important;
    }
  }

  // 设备调试返回值
  .debug-return {
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    padding: 6px 8px;
    background: rgba(43, 56, 66, 1);

    /deep/.el-textarea__inner {
      border: none;
      background: rgba(43, 56, 66, 1);
    }

    .return-tool {
      border-top: 1px dashed rgba(204, 206, 221, 0.5);
      text-align: right;
      padding: 6px 10px 0px;
      margin-top: 5px;

      .btn:hover {
        color: @primaryTextColor;

        .ico-clear {
          background: url(../../../../assets/img/general/Icon_Debug_Delete_Dark.png);
        }

        .ico-copy {
          background: url(../../../../assets/img/general/Icon_Debug_Copy_Dark.png);
        }
      }

      .btn {
        padding: 0px;
        color: rgba(235, 235, 235, 1);
        font-size: 12px;
        cursor: pointer;
      }

      .ico-clear {
        background: url(../../../../assets/img/general/Icon_Debug_Delete.png);
      }

      .ico-copy {
        background: url(../../../../assets/img/general/Icon_Debug_Copy.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
      }
    }
  }

  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }

  // 固件升级状态窗
  .upgradeNew {

    .processstatue,
    .processstatueEquipment {
      font-size: 16px;
      color: #16d09a;
    }

    /deep/.el-progress__text {
      color: #ffffff;
    }

    .progerssComplete,
    .progerssCompleteEquipment {
      background: transparent;
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
// #下拉选框 el-select#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

// 控制项日期选择样式
.select-date .el-input .el-input__inner,
.select-date .el-picker-panel__footer {
  background: #222d35
}

.select-date .el-button {
  background: #222d35;
  color: @primaryTextColor;

  &:hover {
    background: #222d35;
    color: @primaryTextColor;
  }
}
.select-date3.el-time-panel{
     background-color: #222D35 !important;
      color: #fff !important;
      border: none !important;
      border-radius: 8px;
      .el-time-spinner__item.active:not(.disabled){
      color: #fff;
    }
    .el-time-spinner__item:hover:not(.disabled):not(.active){
      background: rgba(255, 255, 255, 0.1);
      color: #FFF;
    }
    .el-button--default{
      background: var(--primaryTextColor, #30D096);
      color: #222d35;
      border: none;
  }
  .el-button.is-disabled.is-plain, .el-button.is-disabled.is-plain:focus, .el-button.is-disabled.is-plain:hover{
      background: var(--primaryColorTransparency30, #30d0956e);
      color: #C0C4CC;
      // opacity: 0.5;
  }
  .el-button--text{
      color: rgba(48, 208, 150);
      display: none;
  }
  .el-button--text:hover{
      color: rgba(48, 208, 150);
  }
  .el-time-panel__btn{
      color: rgba(48, 208, 150);
  }
  }
</style>